/**
 * 同平台多店铺类型共用一个 workspace token / shopType（localStorage）。
 * 另一标签页切换类型后，当前页路径的旧类型段需重定向到新类型，避免 403「暂无权限」。
 */

/**
 * @param {object} opts
 * @param {string} opts.storageKey localStorage 中的店铺类型键
 * @param {string} opts.basePath 如 /ipe/temu
 * @param {(pathname: string) => string} opts.parseSlugFromPath
 * @param {(shopType: string) => string} opts.shopTypeToSlug 中文类型或 slug → 路径 slug
 * @param {string} [opts.gateSegment='gate']
 */
export function installWorkspaceShopTypeRedirect({
  storageKey,
  basePath,
  parseSlugFromPath,
  shopTypeToSlug,
  gateSegment = 'gate',
}) {
  if (typeof window === 'undefined' || !storageKey || !basePath) {
    return () => {};
  }

  const apply = () => {
    let stored = '';
    try {
      stored = localStorage.getItem(storageKey) || '';
    } catch {
      return;
    }
    const newSlug = shopTypeToSlug(stored);
    if (!newSlug) return;

    const path = window.location.pathname || '';
    if (!path.startsWith(basePath)) return;
    if (path.includes(`/${gateSegment}`)) return;

    const currentSlug = parseSlugFromPath(path);
    if (!currentSlug || currentSlug === newSlug) return;

    const oldPrefix = `${basePath}/${currentSlug}`;
    if (!path.startsWith(oldPrefix)) return;

    const rest = path.slice(oldPrefix.length);
    const next = `${basePath}/${newSlug}${rest}${window.location.search || ''}${window.location.hash || ''}`;
    if (next === `${path}${window.location.search || ''}${window.location.hash || ''}`) return;
    window.location.replace(next);
  };

  const onStorage = (event) => {
    if (event.key != null && event.key !== storageKey) return;
    apply();
  };

  const onVisible = () => {
    if (document.visibilityState === 'visible') apply();
  };

  window.addEventListener('storage', onStorage);
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', apply);
  // 进页立刻对齐（从其它标签切回来时 storage 可能已变）
  apply();

  return () => {
    window.removeEventListener('storage', onStorage);
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('focus', apply);
  };
}
